import { AdminFetchTemplatePreview } from 'src/constants/actionTypes'
import type { CollectDataTemplatePreviewResponse } from 'src/interfaces/collectDataTemplatePreview'
import { Action } from 'src/utils/reduxUtils'
import { TemplatePreviewState } from './types'

const getInitialState = (): TemplatePreviewState => ({
  data: null,
  loading: false,
  error: null,
  lastUpdatedAt: null,
})

export const templatePreviewReducer = (
  state: TemplatePreviewState = getInitialState(),
  action: Action<any>,
): TemplatePreviewState => {
  switch (action.type) {
    case AdminFetchTemplatePreview.type.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case AdminFetchTemplatePreview.type.SUCCESS:
      return {
        ...state,
        data: action.payload as CollectDataTemplatePreviewResponse,
        loading: false,
        error: null,
        lastUpdatedAt: Date.now(),
      }
    case AdminFetchTemplatePreview.type.FAILED:
      return {
        ...state,
        loading: false,
        error: 'Failed to load live preview',
      }

    default:
      return state
  }
}
